import {ApisauceInstance} from 'apisauce';

// Url
import {url} from '../api.url';

const categories = (api: ApisauceInstance) => {
	const getAllEbcCategories = () => api.get(url.ebcCategories);
	const getEbcCategoriesById = (id: string) => api.get(url.getEbcCategoriesById(id));

	return {
		getAllEbcCategories,
		getEbcCategoriesById,
	};
};

export default categories;
